module.exports = __webpack_public_path__ + "static/media/orange-t.6e3fa9ac.svg";